
import { Base } from '../base-component';
import './signin-module.component.scss';

export class SigninModule extends Base {

	constructor(element: Element) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/signin-module/signin-module.component.ts